import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../../shared/components/button/CreateButtonTrigger";
import CreateClientCategoryForm from "./CreateClientCategoryForm";

const CreateClientCategoryDialog = ({ onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.detail.tabs.categories.createForm.title"
      description="clients.detail.tabs.categories.createForm.description"
      content={<CreateClientCategoryForm onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientCategoryDialog;
